<script>

import Layout from '@layouts/primary'
import { clientMethods, siteMethods } from '@state/helpers'
import ClientListDatatable from '@components/client-list-datatable'
import ListLoading from '@components/loading'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'ClientReports',
    meta: [{ name: 'description', content: 'ClientReports' }],
  },
  components: { Layout, ClientListDatatable, ListLoading },
  data() {
    return {
      search: '',
      loadingData: true,
      headers: [
        { text: 'Company', value: 'client_name' },
        { text: 'Contact Name', value: 'contact_name' },
        { text: 'Mobile', value: 'mobile' },
        { text: 'Email', value: 'email' },
        { text: 'Actions', value: 'name', sortable: false },
      ],
      clients: [],
      clientId:'',
      isSameAddress: false,
      messagePopUp: false,
      dictionary: {
        attributes: {
          email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'The name field may not be greater than 10 characters',
            // custom messages
          },
          select: {
            required: 'Select field is required',
          },
        },
      },
      addClient: false,
      requestView:false,
      error: {
        uniqueClientName: null,
        uniqueEmail: null
      }
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    this.getClients().then(response => {
      let obj = this.$store.state.clients.objects
      for (var v in obj) {
        this.clients.push(obj[v])
      }
      this.loadingData=false
      // eslint-disable-next-line handle-callback-err
    }).catch(error => {
      this.loadingData=false
    })
  },
  methods: {
    ...clientMethods, ...siteMethods,
    clear() {
      this.newClient.client_name = ''
      this.newClient.address = ''
      this.newClient.suburb = ''
      this.newClient.postcode = null
      this.newClient.phone = ''
      this.newClient.fax = ''
      this.newClient.mobile = ''
      this.newClient.contact_name = ''
      this.newClient.title = ''
      this.newClient.email = ''
      this.newClient.abn = ''
      this.newClient.drivers_licence = ''
      this.$validator.reset()
      this.addClient = false
    },
    changeRoute(r) {
      this.$router.push(r)
    },
  },
}
</script>

<template>
  <Layout>
    <VContainer>
      <h2 :class="$style.routeHeader">
        Client Reports
      </h2>
      <ListLoading :display="loadingData" />
      <ClientListDatatable
        v-if="!loadingData"
        :clients="clients"
        :router-name="'view-client-reports'"
        :action-name="'View Reports'"
      />
    </VContainer>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.routeHeader {
  display: inline-block;
}

.iconSpace{
  margin-right: 4px;
}

.addButton {
  display: inline-block;
  float: right;
}

.error{
    width: 100%;
    padding:25px 25px 0 25px;
    color: red;
    text-align: center;
}

</style>
